import { render, staticRenderFns } from "./SubTaskListItem.vue?vue&type=template&id=61d5cb90&"
import script from "./SubTaskListItem.vue?vue&type=script&lang=ts&"
export * from "./SubTaskListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports